import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { useTranslation } from '../../contexts/TranslationContext';

export default function PWAInstallBanner() {
  const { t } = useTranslation();
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setInstalled(true);
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setDeferred(null);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (installed || dismissed || !deferred) return null;

  const install = async () => {
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[10040] mx-auto flex max-w-lg items-center justify-between gap-3 rounded-xl border border-amber-300/60 bg-[#2a1810]/95 px-4 py-3 text-amber-50 shadow-xl md:left-auto md:right-6">
      <p className="font-marathi text-sm">{t('pwa.installHint')}</p>
      <div className="flex shrink-0 gap-2">
        <button type="button" onClick={install} className="inline-flex items-center gap-1 rounded-lg bg-amber-600 px-3 py-1.5 text-xs font-semibold">
          <Download className="h-3.5 w-3.5" />
          {t('pwa.install')}
        </button>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
